import { FabUser } from '@fabric/components/common';
export class User implements FabUser {
    gmid: string;
    role: string;
    domain: string;
    firstName: string;
    lastName: string;
    displayName: string;
    authorities: string[];
    lastLogin: Date;
    password: string;
    gfsUpdate: number;
    constructor(gmid: string, role: string, domain: string, firstName: string, lastName: string, displayName: string, authorities: string[], lastLogin: Date) {
        this.gmid = gmid;
        this.role = role;
        this.domain = domain;
        this.firstName = firstName;
        this.lastName = lastName;
        this.displayName = displayName;
        this.authorities = authorities;
        this.lastLogin = lastLogin;
        this.password = '';
        this.gfsUpdate = 0;
    }
}
